import React from 'react';
import './Styles.css';

const EstadosLeyenda = ({ estados = [], compact = false }) => {
    return (
        <div
            className={`estados-leyenda-container ${compact ? 'compact' : ''}`}
        >
            {estados.map((estado, index) => (
                <div
                    key={estado.key || index}
                    className="estado-leyenda-item"
                >
                    <div
                        className="estado-leyenda-circulo"
                        style={{ backgroundColor: estado.color }}
                    />
                    <span className="estado-leyenda-label">{estado.label}</span>
                </div>
            ))}
        </div>
    );
};

export default EstadosLeyenda;
